import { XMenu } from './xmenu';
import XAwesomeIcon from './awesomeIcon.vue';
import XTabBar from './tabBar.vue';
import { XTable } from './xtable';
import { XDropdownMenu } from './xDropdownMenu';
import { XToolbar } from './xtoolbar';
import XIcon from './xicon/index.vue';
import XWinTab from './xWinTab/index.vue';
import { XProgress } from './xProgress';
import XTableLayout from './xTableLayout';
import { XEditorLayout } from './xEditorLayout';
import XPaperLayout from './xPaperLayout/xPaperLayout.vue';
import { XAreaSelect } from './xArea';
import XSearchButton from './xSearchButton.vue';
import { XNavLayout, XNavItem } from './xNavLayout';
import XFieldLabel from './xFieldLabel/xFieldLabel.vue';
import XListLayout from './xListLayout/xListLayout.vue';
import XToolbarLayout from './xToolbarLayout/xToolbarLayout.vue';
import XListItem from './xListItem/xListItem.vue';
import XTimerButton from './xtimerButton/xTimerButton.vue';

import { XDialog } from './modal';

export {
    XTimerButton,
    XTableLayout,
    XEditorLayout,
    XToolbarLayout,
    XPaperLayout,
    XAwesomeIcon,
    XTabBar,
    XMenu,
    XTable,
    XDropdownMenu,
    XToolbar,
    XIcon,
    XWinTab,
    XDialog,
    XProgress,
    XAreaSelect,
    XSearchButton,
    XNavLayout,
    XFieldLabel,
    XListLayout,
    XListItem,
    XNavItem,
};

export default {
    install (app) {
        app.component('x-timer-button', XTimerButton);
        app.component('x-table-layout', XTableLayout);
        app.component('x-editor-layout', XEditorLayout);
        app.component('x-toolbar-layout', XToolbarLayout);
        app.component('x-awesome-icon', XAwesomeIcon);
        app.component('x-tab-bar', XTabBar);
        app.component('x-menu', XMenu);
        app.component('x-table', XTable);
        app.component('x-dropdown-menu', XDropdownMenu);
        app.component('x-toolbar', XToolbar);
        app.component('x-icon', XIcon);
        app.component('x-win-tab', XWinTab);
        app.component('x-progress', XProgress);
        app.component('x-dialog', XDialog);
        app.component('x-area-select', XAreaSelect);
        app.component('x-search-button', XSearchButton);
        app.component('x-paper-layout', XPaperLayout);
        app.component('x-nav-layout', XNavLayout);
        app.component('x-nav-item', XNavItem);
        app.component('x-field-label', XFieldLabel);
        app.component('x-list-layout', XListLayout);
        app.component('x-list-item', XListItem);
    },
};
